module.exports = __webpack_public_path__ + "img/step2.f531515a.png";